import en from 'src/core/languages/en.json';
import ptBR from 'src/core/languages/pt-BR.json';
export const resources = {
    en: { translation: en },
    'pt-BR': { translation: ptBR }
};
